var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
import React, { useCallback, useMemo } from "react";
import { Accordion } from "@folio/stripes/components";
import { useIntl } from "react-intl";
import { RecekSelect } from "../inputs";
import { LIBRARY_AGENDA_STATES, parseAgendaState, } from "../../types/agenda";
export var AgendaStateFilter = function (_a) {
    var listType = _a.listType, value = _a.value, onChange = _a.onChange;
    var formatMessage = useIntl().formatMessage;
    var options = useMemo(function () { return __spreadArray([
        {
            value: "",
            label: formatMessage({
                id: "ui-br-legaldeposits.filter.agendaState.any",
            }),
        }
    ], LIBRARY_AGENDA_STATES.map(function (state) { return ({
        value: state,
        label: formatMessage({
            id: "ui-br-legaldeposits.filter.agendaState.".concat(listType, ".").concat(state),
        }),
    }); }), true); }, [formatMessage, listType]);
    var handleChange = useCallback(function (e) {
        return onChange(parseAgendaState(e.target.value));
    }, [onChange]);
    return (React.createElement(Accordion, { label: formatMessage({ id: "ui-br-legaldeposits.filter.agendaState" }), separator: false },
        React.createElement(RecekSelect, { labelId: "ui-br-legaldeposits.filter.agendaState.label", value: value, dataOptions: options, onChange: handleChange, "data-test-id": "agenda-state-filter" })));
};
